import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import AnnouncementBar from "@/components/layout/AnnouncementBar";
import FloatingCTA from "@/components/layout/FloatingCTA";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import OrderPage from "@/pages/OrderPage";
import GalleryPage from "@/pages/GalleryPage";
import Reviews from "@/pages/Reviews";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import FindUs from "@/pages/FindUs";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import SlidersManager from "@/pages/admin/managers/SlidersManager";
import ServicesManager from "@/pages/admin/managers/ServicesManager";
import BanksManager from "@/pages/admin/managers/BanksManager";
import TestimonialsManager from "@/pages/admin/managers/TestimonialsManager";
import FaqsManager from "@/pages/admin/managers/FaqsManager";
import AnnouncementsManager from "@/pages/admin/managers/AnnouncementsManager";
import SettingsManager from "@/pages/admin/managers/SettingsManager";
import LeadsManager from "@/pages/admin/managers/LeadsManager";
import ActivityManager from "@/pages/admin/managers/ActivityManager";

import { primeContent } from "@/lib/content";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC] text-[#111827]">
      <AnnouncementBar />
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default function App() {
  useEffect(() => { primeContent(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/find-us" element={<FindUs />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="leads" element={<LeadsManager />} />
            <Route path="sliders" element={<SlidersManager />} />
            <Route path="services" element={<ServicesManager />} />
            <Route path="banks" element={<BanksManager />} />
            <Route path="testimonials" element={<TestimonialsManager />} />
            <Route path="faqs" element={<FaqsManager />} />
            <Route path="announcements" element={<AnnouncementsManager />} />
            <Route path="settings" element={<SettingsManager />} />
            <Route path="activity" element={<ActivityManager />} />
          </Route>
        </Routes>
        <Toaster richColors position="top-center" offset={80} />
      </BrowserRouter>
    </div>
  );
}
